export const OPPORTUNITIES_PATH = "/opportunities";
